import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Box, IconButton } from "@mui/material";
import React from "react";

import { useNotes } from "api/services/useNotes";
import { FullNotesButton } from "new-components/buttons/FullNotesButton";
import { Typography } from "new-components/typography/Typography";

import { PinnedNoteItem } from "./components/PinnedNoteItem";

export interface PinnedNotesModalProps {
  detectorId: string;
  onOpenFullNotes: () => void;
  onClosePinnedNotes: () => void;
}

export function PinnedNotesModal(props: PinnedNotesModalProps) {
  const { onOpenFullNotes, onClosePinnedNotes, detectorId } = props;

  const { notes: notesData } = useNotes({ detectorId });

  const pinnedNotes = notesData ? [...notesData.CUSTOMER, ...notesData.GL].filter((note) => note.is_pinned) : [];

  if (pinnedNotes.length === 0) return null;

  return (
    <Box
      data-testid="pinned-notes-modal"
      className="fixed top-1/2 right-[30px] transform -translate-y-1/2 rounded shadow-lg w-[350px] bg-[#E5E9ED] z-[1100]"
    >
      <Box className="flex justify-center items-center relative p-3 bg-primary-darker text-white rounded-t">
        <Typography fontWeight="medium">Pinned Notes</Typography>
        <IconButton
          data-testid="close-button"
          className="absolute right-3 top-1/2 -translate-y-1/2 p-0 text-inherit"
          onClick={onClosePinnedNotes}
        >
          <HighlightOffIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          width: "100%",
          padding: 2.5,
          backgroundColor: "#F2F5F6",
          maxHeight: "clamp(0px, 60vh, 560px)",
          overflow: "auto",
        }}
      >
        {pinnedNotes.map((pinnedNote) => (
          <PinnedNoteItem key={pinnedNote.id} note={pinnedNote} />
        ))}
      </Box>
      <Box className="w-full flex items-center justify-end py-3 px-4">
        <FullNotesButton onClick={onOpenFullNotes} />
      </Box>
    </Box>
  );
}
